import { gql } from '@apollo/client';

export const GET_EXHIBITORS = gql`
    query GetExhibitors($eventCode: String!) {
        exhibitors(eventCode: $eventCode) {
            recordId
        }
    }
`;
